// ── Roku publisher-portal taxonomies, as data (ADR-0017 spirit) ──
//
// Captured from the live portal picklists 2026-08-20 (owner screenshots).
// These are UI-layer curation only: storage stays TEXT and the API stays
// permissive, so a portal change can never invalidate stored rows or block
// writes — updating this file is the whole maintenance surface. Re-verify
// against the portal at the fall cert re-check (ring-2 entry gate) and at
// any submission where the operator notices drift.

/**
 * App age rating: value = the short canonical head (fits the 20-char
 * listing cap and reads unambiguously in the operator submission doc);
 * label = the portal's full option wording shown to the customer.
 */
export const ROKU_AGE_RATINGS = [
  { value: 'All Ages', label: 'All Ages - Appropriate for All Audiences' },
  { value: 'Content Rated', label: 'Content Rated - Parental Guidance Advised' },
  { value: 'Content Not Rated', label: 'Content Not Rated - Parental Guidance Advised' },
  { value: 'Adult', label: 'Adult - Not Appropriate for Audiences 17 or Younger' },
] as const;

/**
 * Channel Store categories (the portal's Category picklist — SINGLE
 * select; list owner-confirmed COMPLETE 2026-08-20), stored verbatim in
 * app_cfg_roku.genres. Two portal entries deliberately excluded: the
 * junk lowercase "screenshot" row, and "18" (Roku's adult-content
 * category — not applicable to this platform's offering; re-add here if
 * a legitimate need ever appears).
 */
export const ROKU_GENRES = [
  'Animals & Pets',
  'Apps',
  'Cars & Motorcycles',
  'Classic TV',
  'Comedy',
  'Crime & Mystery',
  'Drama',
  'Educational',
  'eSports & Gaming',
  'Faith-Based',
  'Food & Home',
  'Games',
  'Health & Wellness',
  'How To',
  'International',
  'Lifestyle',
  'Live TV',
  'Local News',
  'Movies & TV',
  'Music',
  'News',
  'Personal Media',
  'Photo Apps',
  'Premium Services',
  'Reality & Pop Culture',
  'Relaxation & Meditation',
  'Rent/Buy Movies',
  'Sci & Tech',
  'Screensavers',
  'Shopping',
  'Special Interest',
  'Sports',
  'Subscription Channels',
  'Themes',
  'Travel',
  'TV en Español',
  'Watch With Cable',
  'Weather',
  'Web Video',
] as const;
